export const LocationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <g clipPath="url(#clip0_1237_239)">
                <path d="M12 2.91016C8.13 2.91016 5 6.04016 5 9.91016C5 15.1602 12 22.9102 12 22.9102C12 22.9102 19 15.1602 19 9.91016C19 6.04016 15.87 2.91016 12 2.91016ZM7 9.91016C7 7.15016 9.24 4.91016 12 4.91016C14.76 4.91016 17 7.15016 17 9.91016C17 12.7902 14.12 17.1002 12 19.7902C9.92 17.1202 7 12.7602 7 9.91016Z" fill="white" />
                <path d="M12 12.4102C13.3807 12.4102 14.5 11.2909 14.5 9.91016C14.5 8.52944 13.3807 7.41016 12 7.41016C10.6193 7.41016 9.5 8.52944 9.5 9.91016C9.5 11.2909 10.6193 12.4102 12 12.4102Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1237_239">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.910156)" />
                </clipPath>
            </defs>
        </svg>
    )
}